function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import FormProvider from '../../contexts/form/form.es.js';

function RenderPaymentForm(_ref, ref) {
  var applicationId = _ref.applicationId,
      cardTokenizeResponseReceived = _ref.cardTokenizeResponseReceived,
      locationId = _ref.locationId,
      children = _ref.children,
      _ref$formProps = _ref.formProps,
      formProps = _ref$formProps === void 0 ? {
    "aria-label": "Payment form",
    id: "rswps-form"
  } : _ref$formProps,
      overrides = _ref.overrides,
      props = _objectWithoutProperties(_ref, ["applicationId", "cardTokenizeResponseReceived", "locationId", "children", "formProps", "overrides"]);

  return /* @__PURE__ */React.createElement(FormProvider, _objectSpread(_objectSpread({}, props), {}, {
    applicationId: applicationId,
    cardTokenizeResponseReceived: cardTokenizeResponseReceived,
    locationId: locationId,
    overrides: overrides
  }), /* @__PURE__ */React.createElement("div", _objectSpread(_objectSpread({
    "data-testid": "rswps-form"
  }, formProps), {}, {
    ref: ref,
    role: "form"
  }), children));
}

var PaymentForm = React.forwardRef(RenderPaymentForm);
export { PaymentForm as default };